import { i18n } from 'platform-lib-app';
export default [
  {
    path: '/news',
    name: 'news',
    component: () => import('./list/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_801'),
      keepAlive: true,
    }
  },
  {
    path: '/news/search',
    name: 'newsSearch',
    component: () => import('./search/index.vue'),
    meta: {
      name: i18n.t('cotti_app_h5_1471'),
      keepAlive: true,
    }
  }
];
